<template>
  <div class="metric-school-map skiptranslate notranslate">
    <a class="map-link no-print-link" :href="googleMapsLink" target="_blank" rel="noopener">
      <div class="map" :style="`width:${mapW}px;height:${mapH}px;`">
        <img :src="`${$STATIC_PATH}/img/nyc_map.png`" alt="Map of NYC With School Location"/>
        <svg v-if="hasMapCoords"><circle class="map-dot" :cx="mapX" :cy="mapY" :r="dotRadius"/></svg>
      </div>
    </a>
    <div class="map-info">
      <div class="address"
        v-for="d in addressSlotData"
        :key="d.component_slot">
        <!-- Link separately on each line so extra whitespace of div isn't clickable -->
        <a class="no-print-link" :href="googleMapsLink" target="_blank" rel="noopener">{{processedValueForAddressSlot(d)}}</a>
      </div>
      <div v-if="isSchoolDataLoaded" class="phone">Phone: {{phoneNumber}}</div>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component'

import MetadataBase from './MetadataBase'

/* Valid Slot Names for this Component */
/* Prefixes (followed by any string) for Valid Slot Names for this Component */
const SN_LAT = 'latitude'
const SN_LONG = 'longitude'
const SN_PHONE = 'phone_number'
const SN_ADDRESS_PREFIX = 'address_'

// Map Coordinates
const LAT_MIN = 40.4855408
const LAT_MAX = 40.9157258
const LONG_MIN = -74.25825
const LONG_MAX = -73.698059

const MAP_SIZE = 120 // in pixels

@Component({
})
export default class MetricSchoolMap extends MetadataBase {
  dotRadius = 4
  mapW = MAP_SIZE
  mapH = MAP_SIZE

  /* Getters */

  get hasMapCoords () { return this.latitude !== undefined && this.longitude !== undefined }

  get latitude () { return this.numValueForSlotName(SN_LAT) }
  get longitude () { return this.numValueForSlotName(SN_LONG) }
  get phoneNumber () { return this.dispValueForSlotName(SN_PHONE) }

  get addressSlotData () { return this.slotDataForPrefix(SN_ADDRESS_PREFIX) }
  get addressSlotValues () { return this.addressSlotData.map(d => this.processedValueForAddressSlot(d)) }
  get searchAddress () {
    // Join multiple lines, remove multiple spaces, convert to +
    return this.addressSlotValues.join(', ').replace(/\s+/g, '+')
  }
  get googleMapsLink () {
    return `https://www.google.com/maps/place/${this.searchAddress}`
  }

  get mapX () {
    return this.longitude !== undefined
      ? this.mapW * (this.longitude - LONG_MIN) / (LONG_MAX - LONG_MIN) : 0
  }
  get mapY () {
    return this.latitude !== undefined
      ? this.mapH * (1 - (this.latitude - LAT_MIN) / (LAT_MAX - LAT_MIN)) : 0
  }

  /* Methods - utility */
  processedValueForAddressSlot (d) {
    const val = this.dispValueForSlot(d)
    return val.replace(/([^,])\s+NY/g, '$1, NY')
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.metric-school-map {
  display: flex;
  > div {
    display: inline-block;
    vertical-align: top;
  }
}
.map-link {
  margin-right: 24px;
}
.map {
  border: 1px solid #777777;
  position: relative;
  img, svg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .map-dot {
    fill: #000080;
  }
}
.map-info {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2018/tab-mods/MetricSchoolMap.vue